import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SidebarService } from '../../core/services/sidebar.service';

@Component({
  selector: 'app-general-buttons',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule],
  templateUrl: './general-buttons.component.html',
  styleUrl: './general-buttons.component.scss'
})
export class GeneralButtonsComponent implements OnInit {
  activeButton = 'usuarios';
  activeGeneral = 'users-table'; // Cambiado a 'users-table' para que coincida con el estado inicial
  page = 1;

  // Mapeo de secciones a rutas
  private routeMap: Record<string, string> = {
    'users-table': '/users',
    'teams': '/teams',
    'aplications': '/apps'
  };

  // Mapeo inverso: de ruta a sección
  private sectionMap: Record<string, string> = {
    '/users': 'users-table',
    '/teams': 'teams',
    '/apps': 'aplications'
  };

  private router = inject(Router);
  private sidebarService = inject(SidebarService);

  ngOnInit() {
    // Sincronizar el estado inicial con la ruta actual
    this.syncWithCurrentRoute();

    // Escuchar cambios de ruta para mantener sincronizado el botón activo
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.syncWithCurrentRoute();
      });
  }

  private syncWithCurrentRoute() {
    const currentUrl = this.router.url;
    const section = this.sectionMap[currentUrl];
    if (section) {
      this.activeGeneral = section;
    }
  }

  selectButton(button: string) {
    this.activeButton = button;
  }

  setActiveGeneral(section: string) {
    if (this.activeGeneral !== section) {
      this.activeGeneral = section;

      if (section === 'users-table' || section === 'teams') {
        this.page = 1;
      }

      // Navegar a la ruta correspondiente
      const route = this.routeMap[section];
      if (route) {
        this.router.navigate([route]);
      }
    }
    // Cerrar el sidebar al seleccionar cualquier opción (incluso si ya estaba seleccionada)
    this.sidebarService.closeSidebar();
  }
}